<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCardHeader>
        <h5><b>DFS Prediction</b></h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="12">
                <CInput placeholder="Enter Quiz Title" v-model="Quiztitle" />
              </CCol>
              <CCol sm="12">
                <CInput
                  placeholder="Enter Quiz question"
                  v-model="Quizquestion"
                />
              </CCol>
              <CCol sm="3">
                <CInput placeholder="Enter option 0" v-model="Quizoptions[0]" />
              </CCol>

              <CCol sm="3">
                <CInput placeholder="Enter option 1" v-model="Quizoptions[1]" />
              </CCol>
              <CCol sm="3">
                <CInput placeholder="Enter option 2" v-model="Quizoptions[2]" />
              </CCol>
              <CCol sm="3">
                <CInput placeholder="Enter option 3" v-model="Quizoptions[3]" />
              </CCol>

              <!-- <CCol sm="6">
                <CInput
                  placeholder="Enter Quiz Answer"
                  v-model.number="Quizanswer"
                  type="hidden"
                />
              </CCol> -->
              <CCol sm="6">
                <CInput
                  placeholder="Enter Quiz point"
                  v-model.number="quizpoint"
                />
              </CCol>

              <CCol sm="12">
                <CRow>
                  <CCol sm="6">
                    <!-- <datetime format="MM/DD/YYYY" width="300px" v-model="val"></datetime> -->
                    <label>Start Date & Time</label>
                    <VueCtkDateTimePicker v-model="starttime" />
                    <!-- <Datepicker
                  format="YYYY-MM-DD h:i:s"
                  v-model="starttime"
                  width="100%"
                /> -->
                    <br />
                  </CCol>

                  <CCol sm="6">
                    <label>End Date & Time</label>
                    <VueCtkDateTimePicker v-model="endtime" />
                    <br />
                  </CCol>
                </CRow>
              </CCol>

              <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Scramble</span
                    >

                    <input
                      v-model="scramble"
                      type="checkbox"
                      value="test"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold">DFS</span>

                    <input
                      v-model="dfs"
                      type="checkbox"
                      value="test"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                  <CCardBody v-if="dfsbody">
                    <CInput
                      placeholder="Enter Match ID"
                      v-model.number="matchId"
                    />
                  </CCardBody>
                </CCard>
              </CCol>
              <CCol sm="12">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="3"><h5>Choose type</h5> </CCol>
                      <CCol sm="2"
                        ><input
                          type="radio"
                          value="normal"
                          v-model="quiztype"
                        />&nbsp;<span style="font-size: large">Normal</span>
                      </CCol>
                      <CCol sm="3"
                        ><input
                          type="radio"
                          value="playAlong"
                          v-model="quiztype"
                        />&nbsp;<span style="font-size: large">Play Along</span>
                      </CCol>
                      <CCol sm="2"> </CCol>
                    </CRow>
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="6">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Status</span
                    >

                    <input
                      type="checkbox"
                      value="test"
                      v-model="status"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>

              <CCol sm="6">
                <div>
                  <div>
                    <label> Quiz Image </label><br />
                    <input
                      type="file"
                      @change="previewImage"
                      accept="image/*"
                    />
                  </div>
                  <div>
                    <p>
                      Progress: {{ uploadValue.toFixed() + "%" }}
                      <progress
                        id="progress"
                        :value="uploadValue"
                        max="100"
                      ></progress>
                    </p>

                    <CButton
                      color="success"
                      @click="onUpload()"
                      v-if="uploadbtn"
                      >Upload</CButton
                    >
                    <br />
                  </div>
                </div>
                <div v-if="imageData != null">
                  <img
                    class="preview"
                    :src="picture"
                    style="width: 200px; height: 200px"
                  />

                  <br />
                  <br />
                </div>
              </CCol>

              <CCol sm="12" style="text-align: center !important">
                <CButton color="success" style="width: 20%" @click="savequiz()"
                  >Save</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import firebase from "firebase";
const db = firebase.firestore();

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import { secondaryDatabase } from "./secondary.js";
import axios from "axios";
//  const Dinodb = firebase.initializeApp(firebaseConfig2);
import moment from "moment";
export default {
  components: { VueCtkDateTimePicker },
  data() {
    return {
      enableDate: false,
      Quiztitle: "",
      Quizquestion: "",
      option1: "",
      option2: "",
      option3: "",
      option4: "",
      Quizoptions: [],
      Quizanswer: "",
      QuizImage: "",
      starttime: "",
      endtime: "",
      quizpoint: "",
      status: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
      uploadbtn: false,
      quiztype: "",
      scramble: false,
      dfs: false,
      dfsbody: false,
      quizimg: true,
      starttimestap: "",
      matchId: "",
      endtimestap: "",
      datebody: false,
    };
  },
  watch: {
    starttime() {
      this.starttimestap = firebase.firestore.Timestamp.fromDate(
        new Date(this.starttime)
      );
    },
    endtime() {
      this.endtimestap = firebase.firestore.Timestamp.fromDate(
        new Date(this.endtime)
      );
    },

    dfs() {
      if (this.dfs == true) {
        this.dfsbody = true;
      } else {
        this.dfsbody = false;
      }
    },
  },
  methods: {
    savequiz() {
      let quizdate = new Date();

      if (this.Quiztitle == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter Quiz TItle",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.Quizquestion == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter Quiz Question",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.starttimestap == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter StartDate",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.endtimestap == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter EndDate",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.Quizoptions.length == 0) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter Quiz Option",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.picture == null) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter Quiz Image",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.quizpoint == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please Enter Quiz Point",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        let messagetitle = "New Prediction Quiz Live on RageFan";
        let messagetext = this.starttimestap
          ? this.Quiztitle +
            " live from " +
            moment(this.starttimestap.seconds * 1000).format(
              "DD-MMM-YYYY , hh:mm:ss:a"
            ) +
            " to " +
            moment(this.endtimestap.seconds * 1000).format(
              "DD-MMM-YYYY , hh:mm:ss:a"
            ) +
            " Answer quickly before it expires."
          : this.Quiztitle + " Answer quickly before it expires";
        let picture = this.picture;
        let data = {
          messagetitle,
          messagetext,
          picture,
        };
        axios.post(
          "https://us-central1-token-geomine.cloudfunctions.net/dfs/sentQuizNotification",
          { ...data }
        );
        // axios.post(
        //   "http://localhost:5000/token-geomine/us-central1/dfs/sentPredictionnotification",
        //   { ...data }
        // );

        secondaryDatabase
          .collection("quizprediction")
          .add({
            quizTitle: this.Quiztitle,
            question: this.Quizquestion,
            options: this.Quizoptions,
            answer: null,
            image: this.picture,
            status: this.status,
            quiztype: this.quiztype,
            starttime: this.starttimestap,
            endtime: this.endtimestap,
            scramble: this.scramble,
            dfs: this.dfs,
            point: this.quizpoint,
            matchId: this.matchId,
            quizdate: firebase.firestore.Timestamp.fromDate(new Date(quizdate)),
          })
          .then(() => {
            this.Quiztitle = "";
            this.Quizquestion = "";
            this.Quizoptions = [];
            this.Quizanswer = "";
            this.picture = "";
            this.status = "";
            this.quiztype = "";
            (this.starttime = ""),
              (this.endtime = ""),
              (this.scramble = ""),
              (this.dfs = ""),
              (this.quizpoint = ""),
              (this.picture = "");
            (this.option1 = ""),
              (this.option2 = ""),
              (this.option3 = ""),
              (this.option4 = "");
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Data Saved Successfully",
              showConfirmButton: false,
              timer: 3000,
            });

            this.$router.push({ name: "TableNft" });
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      }
    },

    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn = true;
      // }
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];

      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {},
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.picture = url;
            if (this.picture.length > 0) {
              this.uploadbtn = false;
            }
          });
        }
      );
    },
  },
  created() {
    // this.leaderboard();
    // this.transactionhash();
  },
};
</script>